import React, { forwardRef, useImperativeHandle, useState } from 'react';
import cn from 'classnames';

import ActionButtons from './ActionButtons';
import CollapseButton from './CollapseButton';
import Title from './Title';
import { ActionButtonType, CollapsableType, TitleType } from './types';
import styles from './section-card.module.scss';
import SecondaryTitle from './SecondaryTitle';


interface ISectionCardProps {
  children?: any;
  title?: TitleType;
  customTitleStyle?: React.CSSProperties;
  collapsable?: CollapsableType;
  actions?: ActionButtonType[];
  padding?: boolean;
  className?: string;
}

function SectionCard(
  props: ISectionCardProps,
  ref: any,
) {
  const {
    collapsable,
    children,
    title,
    customTitleStyle,
    actions = [],
    padding = false,
    className } = props;
  const [isOpen, setIsOpen] = useState<boolean>(collapsable?.defaultOpen ?? true);

  const onClick = () => {
    setIsOpen(!isOpen);

    if (typeof collapsable?.onOpenCallback === 'function') {
      collapsable.onOpenCallback();
    }
  };

  useImperativeHandle(ref, () => ({
    setIsOpen: (isOpenState: boolean) => {
      setIsOpen(isOpenState);
    }
  }));

  return (
    <div
      ref={ref}
      className={cn(styles['ag-section-details'], className, {
        [styles['ag-section-details--open']]: isOpen
      })}
    >
      <div className={styles['ag-section-details__header']}>
        {customTitleStyle && title ? (
          <SecondaryTitle titleStyle={customTitleStyle} title={title} />
        ) : title && (<Title title={title} />)
        }
        <div className={styles['ag-section-details__actions-wrapper']}>
          <ActionButtons actions={actions} />

          {collapsable && !collapsable.disabled && (
            <CollapseButton
              isOpen={isOpen}
              collapsable={collapsable}
              onClick={onClick}
            />
          )}
        </div>
      </div>

      {isOpen && !collapsable?.disabled && (
        <div
          className={cn(styles['ag-section-details__body'], {
            [styles['ag-section-details__body--padding']]: padding
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
}

export default forwardRef(SectionCard);
